"use client"

import React from "react"

interface FooterTextProps {
  text?: React.ReactNode
}

const FooterText: React.FC<FooterTextProps> = ({ text }) => {
  if (!text) return null

  return (
    <div className="flex-none pb-6">
      <div className="mx-auto rounded-md bg-gray-50 p-3 font-nunito text-xs text-gray-600">
        {typeof text === "string" ? <p>{text}</p> : text}
      </div>
    </div>
  )
}

export default FooterText
